import parlors from "goi_common/src/constants/parlors_detail.json";
import { parlorRegion } from "@/constants/parlorRegion";

const { targetSidos } = parlorRegion;

export const regionParlors = parlors.filter((res) =>
  targetSidos.includes(res.sido)
);

export const carouselItems = regionParlors.map((res, i) => {
  return {
    "@type": "ListItem",
    name: `(비용안내) ${res.companyname}`,
    image: `${res.images[0].url}`,
    url: `https://dggb-portal.funeralblog.co.kr/funeral-places/${res.id}/`,
    position: i + 1,
  };
});

export const carouselRichSearch =
  regionParlors.length > 6
    ? {
        "@context": "http://schema.org",
        "@type": "ItemList",
        itemListElement: carouselItems,
      }
    : {};
